import React from 'react';

import { PageTitle } from '../../../components';
import { features } from '../../../constants';



const FeaturePage = () => {

  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Features'} page={'Features'} />

      <section className='features'>
      
      {/* Container for feature items */}
      <div className="box-container">

        {/* Map through the features array and render each feature */}
        {features.map((feature) => (
          <div key={feature.id} className="feature-item">
            <div className='icon'>{feature.icon}</div> {/* Feature icon */}
            <h3>{feature.title}</h3> {/* Feature title */}
            <p>{feature.description}</p> {/* Feature description */}
          </div>
        ))}

      </div>

    </section>
    </> 
  );
}

export default FeaturePage;